import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";
import AddCCAccessLevelRoleForm from "./AddCCAccessLevelRoleForm";

const AddCCAccessLevelRoleDialog = ({ onSubmitHandler, roles }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Añadir rol"
      description="Añadir un rol a los permisos de visualización de páginas y menús de Control Centre"
      content={
        <AddCCAccessLevelRoleForm onSubmitHandler={onSubmit} roles={roles} />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default AddCCAccessLevelRoleDialog;
